<div class="">
    <div class="container-fluid content-bg">
        <div class="card card-login mx-auto mt-5">
            <div class="card-header">Login
                <button type="button" class="close" data-dismiss="modal" (click)="loginClose()">&times;</button>
            </div>
            <div class="card-body">
                <form id="loginform">
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" class="form-control" id="email" name="email" ngModel #emailref="ngModel" [(ngModel)]="email">
                        <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)" class="alert alert-danger">
                            <div [hidden]="!emailref.errors?.pattern">
                                Invalid pattern
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="password">Password</label>
                        <show-hide-password size="md" btnStyle="primary" [btnOutline]="false">
                            <input id="password" [(ngModel)]="password" type="password" name="password">
                        </show-hide-password>
                    </div>
                    <input type="submit" (click)="loginFunction()" class="btn btn-primary btn-block" value="Login" />
                </form>
                <div class="text-center">
                    <a href="register" class="d-block small mt-3" style="font-size: 15px;">Register an Account</a>
                    <a href="forgot_email" class="d-block small mt-2" style="font-size: 13px;"><span>Forgot Password?</span></a>
                    <br>
                    <a href="home" class="d-block small">Back To Home</a>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="forgotpasswordModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Forgot Your Password ?</h5>
                    <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
                </div>
                <div class="modal-body">
                    <form class="forgotpassword" name="forgotpassword" id="forgotpassword">
                        <strong>Email</strong><br />
                        <input type="text" id="emailForgot" name="emailForgot" class="form-control" placeholder="Enter Email">
                        <span id="errmesg" style="color:red"></span>
                        <div class="modal-footer">
                            <span id="succMsg1" class="successMsg"></span>
                            <span id="errMsg1" class="failMsg"></span>
                            <button class="btn btn-success" id="submit">Send</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white">Loading </p>
    </ngx-spinner>
</div>